// libs
import React from "react";
import isEmpty from "lodash/isEmpty";

// helpers
import { getCookie } from "helpers/utils";

// defs
interface IInitialCallsProps {
    fetchUser: () => any;
    selectedCurrency: string;
    selectedCountryCode: string;
    selectedCountryName: string;
    fetchOffer: () => void;
    setDefaultCookies: (body: { [key: string]: string }) => void;
}

class InitialCalls extends React.PureComponent<IInitialCallsProps> {
    public componentDidMount() {
        const {
            fetchUser,
            fetchOffer,
            selectedCurrency,
            selectedCountryName,
            selectedCountryCode,
            setDefaultCookies,
        } = this.props;

        fetchUser();
        fetchOffer();

        if (
            isEmpty(getCookie("CurrencyCode")) ||
            isEmpty(getCookie("countryName")) ||
            isEmpty(getCookie("countryNameFull"))
        ) {
            const body = {
                curr: selectedCurrency,
                countrycode: selectedCountryCode,
                countryname: selectedCountryName,
            };

            setDefaultCookies(body);
        }
    }

    public render() {
        return null;
    }
}

export default InitialCalls;
